import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import { loading, userPrefPageSize } from '@/decorators';

var SystemLogProductPage = function (_super) {
  __extends(SystemLogProductPage, _super);

  function SystemLogProductPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.dataList = [];
    _this.loadingStatus = false;
    _this.columns = [];
    _this.datetimeDefaultValue = _this.$util.getDefaultTimeCondition();
    _this.searchData = _this.getInitSearchData();
    _this.lastParams = {};
    _this.total = 0;
    return _this;
  }

  SystemLogProductPage.prototype.onDatetimeDefaultValueChange = function (arr) {
    if (arr.length) {
      this.searchData.start_time = this.$util.formatDateTime(arr[0]);
      this.searchData.end_time = this.$util.formatDateTime(arr[1]);
    } else {
      this.searchData.start_time = '';
      this.searchData.end_time = '';
    }
  };

  SystemLogProductPage.prototype.created = function () {
    this.columns = [{
      title: this.t('商品编码'),
      dataIndex: 'product_sku',
      filterEmpty: true
    }, {
      title: this.t('操作人'),
      dataIndex: 'user_name',
      filterEmpty: true
    }, {
      title: this.t('日志'),
      scopedSlots: {
        customRender: 'remark'
      }
    }, {
      title: this.t('日志时间'),
      dataIndex: 'add_time',
      filterEmpty: true
    }];
    this.queryProductLogList();
  };

  SystemLogProductPage.prototype.queryProductLogList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data, list, total;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.lastParams = this.$util.deepCopy(this.searchData);
            return [4, this.$api.assistant.queryProductLogList(this.searchData)];

          case 1:
            data = _a.sent().data;
            list = data.list, total = data.total;
            this.dataList = this.$util.createTableRowKey(list);
            this.total = total;
            return [2];
        }
      });
    });
  };

  SystemLogProductPage.prototype.getInitSearchData = function () {
    return {
      page_index: 1,
      page_size: 10,
      code_field: 'product_sku',
      code_value: '',
      start_time: '',
      end_time: ''
    };
  };

  SystemLogProductPage.prototype.handlePageChange = function (val) {
    this.initPage();
    this.searchData.page_index = val;
    this.queryProductLogList();
  };

  SystemLogProductPage.prototype.handleTabChange = function (key) {
    this.initPage();
    this.queryProductLogList();
  };

  SystemLogProductPage.prototype.initPage = function () {
    this.searchData.page_index = 1;
  };

  SystemLogProductPage.prototype.handleSearch = function () {
    this.initPage();
    this.queryProductLogList();
  };

  SystemLogProductPage.prototype.handleReset = function () {
    var _this = this;

    this.searchData = this.getInitSearchData();
    this.datetimeDefaultValue = this.$util.getDefaultTimeCondition();
    this.$nextTick(function () {
      return _this.queryProductLogList();
    });
  };

  __decorate([Watch('datetimeDefaultValue', {
    immediate: true
  })], SystemLogProductPage.prototype, "onDatetimeDefaultValueChange", null);

  __decorate([loading('loadingStatus')], SystemLogProductPage.prototype, "queryProductLogList", null);

  __decorate([userPrefPageSize('systemLogProductList')], SystemLogProductPage.prototype, "getInitSearchData", null);

  SystemLogProductPage = __decorate([Component], SystemLogProductPage);
  return SystemLogProductPage;
}(Vue);

export default SystemLogProductPage;